import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ErrorAlert from '../ErrorAlert'
import QuantityField from '../QuantityField'
import { t } from '../../utils/i18n'
import ChoiceConfirmation from '../ChoiceConfirmation'
import Modal from '../Modal'
import Popover from '../Popover'
import { addToCartSubmit, cartDisclaimerClicked } from '../../actions'
import { State } from 'shared'

const AddToCartPopover: React.FC = () => {
  const dispatch = useDispatch()

  const { addToCart, cartDisclaimer } = useSelector((state: State) => state)

  const { errors, submitting } = addToCart

  if (cartDisclaimer) {
    document.body.classList.add('dimmed')
    return <Modal method={() => dispatch(addToCartSubmit())} type="delay" />
  }

  return (
    <Popover
      width="300px"
      alignTo={
        window.innerWidth > 768
          ? '.velorbis-customizer-header-add-to-cart-desktop'
          : '.velorbis-customizer-header-add-to-cart-mobile'
      }
      position="below"
    >
      <div className="velorbis-customizer-popover-header">
        {t('add_to_cart_button')}
      </div>
      <div className="velorbis-customizer-popover-body velorbis-customizer-popover-body-scroll velorbis-customizer-space-dist-v">
        <ChoiceConfirmation />
        <QuantityField />
        <ErrorAlert errors={errors} />
        <div className="velorbis-customizer-popover-buttons">
          <button
            className="velorbis-customizer-button"
            onClick={() => dispatch(cartDisclaimerClicked())}
            disabled={submitting}
          >
            {t('add_to_cart_button')}
          </button>
        </div>
      </div>
    </Popover>
  )
}

export default AddToCartPopover
